import React from 'react'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { getFullInfo } from '../store/reducers/visits';
import { fetchingState } from '../helpers/hocs.js'
import Calendar from 'rc-year-calendar';
import 'rc-year-calendar/locales/rc-year-calendar.ru';
import { sendDates, sendFeedback } from '../store/reducers/visits';
import { getLoggedUser, getIsLogged } from '../selectors/user'
import page from 'page';
import moment from 'moment';
import MainContainer from './Main'
import Overlay from '../components/Overlay'
import SidebarVisits from '../components/Profile/SidebarVisits'
import ContactToManager from '../components/Visits/ContactToManager'
import VisitCalendar from '../components/VisitCalendar'
import Close from '../components/Icons/Close'
import NotFound from './404'
import BookDetect from '../components/BookDetect'

const MeetingPage = ({ info = {}, role, showFormEventPopup, setFormEventPopup, showGratitude, setShowGratitude, error = false,
  prepareDate, activeElemDate = null, setActiveDate, sendOneDateOfVisit, showAnotherDatePopup, user, onSave,
  setAnotherDatePopup, errorComment, comment, commentHandler, requestForReselectDates, reselectMessageComplete , booking, setBooking, tmpData, setInput, errorsData, place}) => {
  let expired = (info && info.visitDates && info.visitDates.tries && info.visitDates.tries === 3) ? true : false;//переменная обозначает прошло или нет 3 раунда по 48 часов

  if (isEmpty(info)) {
    return null
  }
  else if ((role && role === 'person' && user.person._id == info.persons[0]._id)
  || (role && role === 'unautorized' && (!info.visitDates.person || info.visitDates.person.length === 0) && (!info.visitDates.user || info.visitDates.user.length === 0))
  ) {

    return (
      ((!info.visitDates.person || info.visitDates.person.length === 0) && (!info.visitDates.user || info.visitDates.user.length === 0)) ?
        <MainContainer>
          <div className='visits-innerWrapper'>

            <div className='page-for-person'>
              <div className='visits-calendar'>
                <h1 style={{ marginTop: 0 }}>
                  Выбор даты и времени для встречи с меценатом {` ${info.user.name} ${info.user.surname}`}
                </h1>
                <div className={`calendar-wrapper ${(info.visitDates && info.visitDates.user && info.visitDates.user.length > 0) || expired ? '_blocked' : ''}`}>
                  <Overlay isActive={showFormEventPopup} onClose={() => setFormEventPopup(false)} klassModifier={"mfc-modal_3 ProfileContainer__visits-modal"}>
                    <VisitCalendar visit={info} role={'person'} personId={info.persons[0]._id} onSave={() => { setShowGratitude(true); setFormEventPopup(false); }} />
                  </Overlay>
                  <Overlay isActive={showGratitude} onClose={() => setShowGratitude(false)} klassModifier={"welcome-persone mfc-modal_4"}>
                    <div className='ProfileContainer__modal ProfileContainer__modal_red' style={{ position: "relative" }}>
                      <div className='ProfileContainer__modal-wrapper'>
                        <div className='ProfileContainer__modal-header'>
                          <p className='ProfileContainer__modal-header-title'>
                            Спасибо за выбор!
                          </p>
                        </div>
                        <div className='ProfileContainer__modal-main'>
                          Мы передаем ваши опции меценату. После выбора мецената вам придет уведомление. И конечно, вы всегда можете связться с менеджером, если вам нужна поддержка
                        </div>
                        <ContactToManager info={info} role={'person'} classList='Button Button_black Button_black-white' />
                      </div>
                       <div className='ProfileContainer__modal-close' onClick={onSave}><Close /></div>
                    </div>
                  </Overlay>

                  {!expired &&
                    <div className='buttonControl'>
                      <button className="Button Button_black" onClick={(e) => setFormEventPopup(true)}>Назначить время встречи</button>
                      {/* {eventDates.length > 0 && <button className='Button Button_black _clearDate' onClick={(e) => clearDate(e)} >Выбрать другие даты</button>} */}
                      <ContactToManager info={info} role={'person'} />
                    </div>
                  }
                </div>
                {expired && <ContactToManager info={info} role={'person'} classList='Button Button_black ' />}
              </div>

            </div>
          </div>
        </MainContainer>

        :


        <MainContainer
          Sidebar={<SidebarVisits info={info} role={'person'} />}
        >
          
          <h1 className='data-success'>
            Указанные вами данные по времени встречи успешно сохранены
          </h1>
          
          <ContactToManager info={info} role={'person'}  classList='Button Button_black Button_black-white'/>

        </MainContainer>
    )

  }
  else if ((role && role === 'user' && user._id === info.user._id)
  || (role && role === 'unautorized' &&  (info.visitDates.person && info.visitDates.person.length > 0))
  ) {
    return (
      (info.visitDates.person && info.visitDates.person.length > 0) ?

        <MainContainer>
          <div className='visits-innerWrapper'>
            <div className='page-for-user'>


              <div>
                {(!info.visitDates.user || !info.visitDates.user.length > 0)
                  ?
                  <div>
                    <h1>Выберите одну дату из предложенных персоной <i>{` ${info.persons[0].descriptions[0].firstname} ${info.persons[0].descriptions[0].lastname}`}</i></h1>
                    <div className='choose-date-of-user'>
                      {info.visitDates.person.map(date =>
                        date === activeElemDate
                          ?
                          <div className='choose-date _active'
                            key={date.toString()}
                            value={date.toString()}
                            onClick={(e) => setActiveDate(e)}
                          >{prepareDate(date)}</div>
                          :
                          <div
                            className='choose-date'
                            key={date.toString()}
                            value={date.toString()}
                            onClick={(e) => setActiveDate(e)}
                          >{prepareDate(date)}</div>
                      )}
                    </div>
                    <div className="moskow-time">(<FormattedMessage id='moskow_time' />)</div>
                        {place && place.length > 0 &&
                          <div style={{marginTop: '10px'}} className='place'>
                            {`Место встречи: ${place}`}
                          </div>
                        }
                    <button className='Button Button_black' onClick={(e) => sendOneDateOfVisit(e)}>Выбрать дату</button>
                    <div className='AnotherDate'>
                      <button className='Button Button_black _another-date' onClick={() => setAnotherDatePopup(true)}>Запросить другие даты</button>
                      <Overlay isActive={showAnotherDatePopup} onClose={() => setAnotherDatePopup(false)} klassModifier='is--blured'>
                        {showAnotherDatePopup &&
                          <div className='EmailPopup ReselectDates'>
                            <h1 className='EmailPopup-h1 EmailPopup-h1-connection'>
                              Напишите почему вам не подходят предложенные даты
                            </h1>
                            {!reselectMessageComplete
                              ?
                              <div className='EmailPopup-kontainer ReselectDates__container'>
                                <div className='EmailPopup-select'>
                                  <input
                                    type="text"
                                    className='EmailPopup__field ReselectDates__field'
                                    name="comment"
                                    autoFocus
                                    onChange={(e) => commentHandler(e)}
                                    value={comment}
                                  // minLength={50}
                                  // maxLength={140}
                                  // length={comment ? comment.length : 0}
                                  />
                                </div>
                                {(errorComment && showAnotherDatePopup) && <p className='Text GiftCardsCheck__text'><FormattedMessage id='request_of_user.reselect_date.error' /></p>}
                                <button className='EmailPopup-submit ReselectDates__send' onClick={requestForReselectDates}><FormattedMessage id='form.send' /></button>
                              </div>
                              :
                              <div className='ReselectDates__request-complete'>
                                Ваш запрос отправлен
                              </div>
                            }
                          </div>
                        }
                      </Overlay>
                    </div>
                    {error && <p className='Text GiftCardsCheck__text'>Вы не выбрали дату!</p>}
                        {info.visitDates && info.visitDates.booking && info.visitDates.booking === 'user' &&
                          <BookDetect
                            title='Персона предлагает вам забронировать место встречи'
                            target='выбрать место встречи'
                            booking={booking}
                            setBooking={setBooking}
                            tmpData={tmpData}
                            setInput={setInput}
                            errors={errorsData}
                          />
                        }
                  </div>
                  :
                  <div className='final-date'>
                    <h1>Для встречи с персоной <i>{` ${info.persons[0].descriptions[0].firstname} ${info.persons[0].descriptions[0].lastname}`}</i> была выбрана дата:</h1>
                    <div className='final-date-value'>{prepareDate(info.visitDates.user[0])} (<FormattedMessage id='moskow_time' />)</div>
                        {place && place.length > 0 &&
                            <div style={{marginTop: '15px'}} className='place'>
                                {`Место встречи: ${place}`}
                            </div>
                        }
                  </div>
                }


                {/* <h1 className='data-success'>
                    Выбранная вами дата встречи с персоной <i>{` ${info.persons[0].descriptions[0].firstname} ${info.persons[0].descriptions[0].lastname}`}</i>  успешно сохранена
                </h1>} */}
                <ContactToManager info={info} role={role} />
              </div>

            </div>
          </div>
        </MainContainer>
        :
        <MainContainer
          Sidebar={<SidebarVisits info={info} role={role} />}
        >
          {expired//условие если прошло 3 круга по 48 часов
            ?
            <ContactToManager info={info} role={role} classList='Button Button_black' />
            :
            <div>
              <h1>Персона <i>{` ${info.persons[0].descriptions[0].firstname} ${info.persons[0].descriptions[0].lastname}`}</i> еще не выбрала даты для встречи</h1>
            </div>
          }
        </MainContainer>
    )


  }
  else return (<NotFound />)
}

const mapStateToProps = state => ({
  info: state.visit.info,
  user: getLoggedUser(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({ getFullInfo, sendDates }, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...props,
  ...state,
  getData: async (id) => {
    let visitId = id || props.id;
    dispatch.getFullInfo(visitId)
  },
  sendDates: (data) => {
    return (props.fetchingWrap(dispatch.sendDates.bind(this, data), 'send'))
  },
  /*visitsNotifications: (data) => {
    return(props.fetchingWrap(dispatch.visitsNotifications.bind(this, data), 'reselect'))
  }*/
})


export default injectIntl(compose(
  withState('activeElemDate', 'setActiveElem', null),//состояние акивного элемента, который выбрал меценат
  withState('time', 'setTime', '00:00'),//время по умолчанию при выборе даты
  withState('timeError', 'setETimerror', false),//свойства ошибкивремени,
  withState('error', 'setError', false),//свойства ошибки, которые будут запрещать установку времени встречи, если она введена некорректно
  withState('currentDate', 'setCurrentDate', null),//получение текущей даты по клику в календаре
  withState('eventDates', 'setDate', []),//свойство хранящее наши даты, которые выбрала персона
  withState('success', 'setSuccess', null),
  withState('showFormEventPopup', 'setFormEventPopup', false),//показывать или нет форму добавления даты встречи
  withState('showGratitude', 'setShowGratitude', false),//показывать или нет форму добавления даты встречи
  withState('showAnotherDatePopup', 'setAnotherDatePopup', false),//показывать форму запроса других дат от персоны
  withState('errorComment', 'setErrorComment', false),
  withState('comment', 'setComment', ''),
  withState('reselectMessageComplete', 'setReselectMessageComplete', false),//показывать или нет сообщение об успешной отправке запроса от мецената на смену персоной дат встречи
  withState('booking', 'setBooking', false),
  withState('tmpData', 'setTmpData', {}),
  withState('errorsData', 'setErrorsData', {}),//ошибка заполнения полей места встречи
  withState('errorBooking', 'setErrorBooking', false),
  withState('place', 'setPlace', ''),//место встречи
  fetchingState({ multi: true }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    prepareDate: () => (item) => moment(item).add(3, 'hours').utc().format('DD.MM.YYYY HH:mm'),
    setActiveDate: ({ setActiveElem }) => (e) => {
      e && e.preventDefault();
      setActiveElem(e.target.getAttribute('value'));
    },
    sendOneDateOfVisit: ({ info, getData, data, setSuccess, activeElemDate, sendDates, setError, error,
      setActiveElem, role, booking, tmpData, setErrorsData, setPlace }) => async (e) => {
      e && e.preventDefault();
      const dates = [];
      if (activeElemDate) {
        dates.push(new Date(activeElemDate));
        data = {
          visitId: info._id,
          dates: dates,
          role: 'user'
        };
        if (!navigator.onLine) {
          alert("Потеряно интернет-соединение! Попробуйте позже")
        }
        if (booking) {
          let errors = {};
          if (!tmpData.placeName || tmpData.placeName.length === 0) errors.placeName = true
          if (!tmpData.place || tmpData.place.length === 0) errors.place = true
          setErrorsData(errors)
          if (Object.keys(errors).length > 0) return
          data.placeName = tmpData.placeName
          data.place = tmpData.place
          setPlace(`${tmpData.place} - ${tmpData.placeName}`)
        }

        const result = await sendDates(data);
        if (result === 200) {
          setSuccess(true);
          setActiveElem(null)
          if (error) setError(false);
          if (document.body.classList.contains('jivo-visible')) document.body.classList.remove('jivo-visible')
          window.jivo_destroy()
          await getData()
          setTimeout(() => {
            setSuccess(null);
            if (role === 'unautorized') page.redirect('/');
          }, 3000);
        }
      } else {
        setError(true);
      }
    },
    commentHandler: ({ setComment }) => (e) => {
      //ввод комментария от мецената для смены дат 
      setComment(e.target.value)
    },
    setInput: ({ setTmpData, tmpData }) => field => e => {//запись данных при записи в input
      tmpData[field] = e.target.value
      setTmpData(tmpData)
    },
    poopityScoop: () => (e) => {
      window.ononline = (e) => {
        console.log("Back Online")
        alert("Вы снова онлайн!")
      };

      window.onoffline = (e) => {
        console.log("Connection Lost")
        alert("Соединение потеряно")
      };
    },
    onSave: ({role, setShowGratitude}) => (e) => {
      setShowGratitude(false);   
      if (role === 'unautorized') {
        page.redirect('/'); 
      }
      else 
      {
        document.location.reload(); 
      }
    },
    requestForReselectDates: ({ sendDates, getData, comment, info, setErrorComment, errorComment, setAnotherDatePopup, setReselectMessageComplete, setComment, role }) => async (e) => {
      //отправка запроса на изменение дат
      e && e.preventDefault();
      if (comment.length > 5) {
        const data = {
          visitId: info._id,
          comment: comment,
          notAgree: true
        }
        if (!navigator.onLine) {
          alert("Потеряно интернет-соединение! Попробуйте позже")
        }
        const result = await sendDates(data)
        if (result === 200) {
          if (role === 'unautorized') page.redirect('/');
          if (errorComment) setErrorComment(false)
          setReselectMessageComplete(true)
          setComment('')
          await getData()
          setTimeout(() => {
            setAnotherDatePopup(false)
            setReselectMessageComplete(false)
          }, 2000);
        }
      } else {
        setErrorComment(true)
      }
    }
  }),

  lifecycle({
    async componentWillMount() {
      await this.props.getData()
    },
    async componentWillReceiveProps(np) {
      this.props.poopityScoop();
      if (np.id && (np.id !== this.props.id)) {
        await this.props.getData(np.id)
      }
      if ((np.info && np.info.visitDates) && !this.props.info.visitDates) {

        if (np.info.visitDates.person && np.info.visitDates.person.length > 0
          && (!np.info.visitDates.user || np.info.visitDates.user.length === 0)) {
          const savedDates = np.info.visitDates.person.map(date => ({
            startDate: new Date(date),
            endDate: new Date(date),
          }))
          this.props.setDate(savedDates)
        }
        if (np.info.visitDates.user && np.info.visitDates.user.length > 0) {
          const savedDates = np.info.visitDates.user.map(date => ({
            startDate: new Date(date),
            endDate: new Date(date),
          }))
          this.props.setDate(savedDates)
        }
      }
      if (Object.keys(np.info).length > 0 && Object.keys(this.props.info).length === 0 && (np.info.place && np.info.placeName)) {
        this.props.setPlace(`${np.info.place} - ${np.info.placeName}`)
      }
        
      if (np.booking !== this.props.booking) {
        if (!np.booking) {
            if (document.body.classList.contains('jivo-visible')) {
                document.body.classList.remove('jivo-visible');
                window.jivo_destroy();
            }
        } else {
            document.body.classList.add('jivo-visible')
            window.jivo_init();
            setTimeout(() => {
                window.jivo_api.open();
            }, 100);
        }
      }
    },
    componentWillUnmount() {
      if (document.body.classList.contains('jivo-visible')) document.body.classList.remove('jivo-visible')
      window.jivo_destroy()
    }
  })
)(MeetingPage))


// WEBPACK FOOTER //
// ./src/containers/Meeting.jsx